import React from 'react'

export const DeviceRepairEligibility = ({
  eligibilityDetails,
  warningMessages,
}) => {
  const { coverageCode, coverageDescription, technicianMandatory } =
    eligibilityDetails
  return (
    <ol>
      <li>
        <strong>Coverage</strong> : {coverageCode} - {coverageDescription}
      </li>

      <li>
        <strong>Is Technician Mandatory</strong> :{' '}
        {technicianMandatory ? 'Yes' : 'No'}
      </li>

      {warningMessages?.map((message) => {
        return <li>{message}</li>
      })}
    </ol>
  )
}
